import { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  useUpdateWritingMutation,
} from '../../../generated/graphql';
import { openSnackbar } from '../../../components/Notifier';
import getErrorMessage from '../../../utils/getErrorMessage';
import { NotifierType } from '../../../variables/types';
import { SubmitTaskContext } from '../submit-task-context';
import { DELETED_ASSIGNMENT_MESSAGE, SUBMISSION_DOES_NOT_EXIST_ERROR } from '../../../variables/constant';
import { escapingSpecialCharacters, unescapeSpecialCharacters } from '../../../utils/handleEscapeCharacters';

const useWritingTask = () => {
  const history = useHistory();
  const {
    id,
    submission,
    setShowSuccess,
  } = useContext(SubmitTaskContext);
  const [writing, setWriting] = useState(unescapeSpecialCharacters(submission?.writing || ''));
  const [openWritingModal, setOpenWritingModal] = useState(false);
  const [updateWritingForAssignment, { loading }] = useUpdateWritingMutation();
  const {
    updateStatus,
  } = useContext(SubmitTaskContext);

  useEffect(() => {
    if (submission?.writing) {
      setWriting(unescapeSpecialCharacters(submission?.writing));
    }
  }, [submission]);

  const updateWriting = async () => {
    if (!id) {
      return;
    }
    try {
      const response = await updateWritingForAssignment({
        variables: {
          id,
          writing: escapingSpecialCharacters(writing?.trim()),
        },
      });
      if (response?.data?.updateWriting?.id) {
        updateStatus?.(response?.data?.updateWriting?.status);
      }
      return response?.data?.updateWriting?.id
    } catch (error) {
      if (getErrorMessage(error) === SUBMISSION_DOES_NOT_EXIST_ERROR) {
        openSnackbar({
          message: DELETED_ASSIGNMENT_MESSAGE,
        }, NotifierType.Error);
        history.replace('/');
      } else {
        openSnackbar({ message: getErrorMessage(error) }, NotifierType.Error);
      }
    }
  };

  return {
    writing,
    setWriting,
    loading,
    updateWriting,
    openWritingModal,
    setOpenWritingModal,
  };
};

export default useWritingTask;
